jQuery(document).ready(function ($) {
    const menuItems = $('.wp-block-mega-menu-item__content');
    const breakpoint = 992;

    // This function allows the .hs-dropdown-toggle to toggle the mega menu dropdown on mobile screens, 
    // while navigating to the linked page on desktop screens.
    function handleHrefAttribute() {
        menuItems.each(function () {
            const item = $(this);
            if ($(window).width() < breakpoint) {
                item.removeAttr('href');
            } else {
                item.attr('href', item.data('url'));
            }
        });
    }

    function updateCurrentClass() {
        const currentPath = window.location.pathname.replace(/\/$/, '');
        const allLinks = $('.wp-block-mega-menu-item__content, .wp-block-navigation-item__content');

        allLinks.each(function () {
            const link = $(this);
            const linkPath = new URL(link.attr('href'), window.location.origin).pathname.replace(/\/$/, '');

            if (currentPath === linkPath) {
                link.addClass('font-medium');
                // If it's a child link, also add class to parent
                const parentDropdown = link.closest('.hs-dropdown');
                if (parentDropdown.length) {
                    const parentLink = parentDropdown.find('.wp-block-mega-menu-item__content').first();
                    if (parentLink.length) {
                        parentLink.addClass('font-medium');
                    }
                }
            } else {
                link.removeClass('font-medium');
            }
        });
    }

    handleHrefAttribute();
    updateCurrentClass();

    $(window).on('resize', handleHrefAttribute);
    $(window).on('popstate', updateCurrentClass);

    // Core/navigation block interaction
    $('.wp-block-navigation__responsive-container-close').on('click', function() {
        if ($(window).width() < breakpoint) {
            const openDropdowns = $('.hs-dropdown.hs-dropdown-open');
            const openMenus = $('.hs-dropdown-menu:not(.hidden)');
            
            openDropdowns.removeClass('hs-dropdown-open');
            openMenus.addClass('hidden');
            $('.hs-dropdown-toggle').attr('aria-expanded', 'false');
        }
    });

});
